import { createRouter, createWebHistory } from 'vue-router';
import { setLogger } from '@general/js/utils/Logger';
import View from '@/components/componentView.vue';
import store from '@/store';

// Routes per category
import IpsiCreditCardForm from '@general/js/components/IpsiCreditCardForm.vue';
import ErrorPages from './Errors';
import MemberExclusives from './MemberExclusives';
import MemberMenu from './MemberMenu';
import MyClaims from './MyClaims';
import MyCover from './MyCover';
import NonNavPages from './NonNavPages';
import Support from './Support';

import PolicySelection from '../views/PolicySelection.vue';
import Home from '../views/Home.vue';

// Dev only routes
import Test from '../views/Test.vue';
import BenefitQuotesAndClaimsHome from '../views/BenefitQuotesAndClaims/BenefitQuotesAndClaimsHome.vue';
import MakeAPaymentCRM from '../views/MyCover/Payments/MakeAPaymentCRM.vue';

import { MY_DETAILS_POLICY_SELECTION, HOME, CONTACT_US } from './routeNames';

// Setting the global logger to be used
setLogger();

let routes = [
  {
    path: '/',
    name: MY_DETAILS_POLICY_SELECTION,
    component: PolicySelection,
    meta: {
      title: 'Policy Selection',
      displayMode: 'condensed',
    },
  },
  {
    path: '/:policyNumber',
    component: View, // TODO: This need to be replaced to actual home component when it is developed
    beforeEnter: (to) => {
      // this is to make sure MP opened in new tab have right policy number stored in vuex state
      const policyNumber = to.params.policyNumber;
      if (window.localStorage.getItem('currentPolicyNumber') === 'not-selected' && policyNumber) {
        store.commit('saveThisPolicyNumber', policyNumber);
      }
    },
    meta: {
      title: 'Home',
    },
    children: [
      {
        path: '',
        name: HOME,
        component: Home,
      },
      ...MyClaims,
      ...MyCover,
      ...MemberExclusives,
      ...MemberMenu,
      ...Support,
      ...NonNavPages,
    ],
  },
  // TODO: this to be updated/removed when refactoring navigation
  {
    path: '/support/contact-us',
    redirect: {
      name: CONTACT_US,
      params: { policyNumber: JSON.parse(sessionStorage.getItem('vuex'))?.thisPolicy || window.localStorage.getItem('currentPolicyNumber') },
    },
  },
];

// Add error page routes
routes = routes.concat(ErrorPages);

// Development only routes
if (process.env.NODE_ENV === 'development') {
  routes = routes.concat([
    {
      path: '/test',
      name: 'test',
      // route level code-splitting
      // this generates a separate chunk (Test.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Test,
    },
    {
      path: '/test/ipsi',
      name: 'IpsiCreditCardForm',
      component: IpsiCreditCardForm,
    },
    {
      path: '/crm/benefit-quote',
      component: BenefitQuotesAndClaimsHome,
      props: {
        isClaim: false,
      },
    },
    { // Need to run `node run server` in the CRMVueApps folder to start the local CRM proxy server.
      path: '/crm/make-a-payment',
      component: MakeAPaymentCRM,
      beforeEnter: (to) => {
        to.params.policyNumber = "BC2007"; // Set policy number to mock data so that we can test MakeAPayment CRM app without crashes
      }
    },
  ]);
}

logger.log('The routes are: ', routes);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { left: 0, top: 0 };
  },
});

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} – Defence Health`;
  } else {
    document.title = 'Defence Health'; // default document title if title for each route undefined
  }
});

export default router;
